import iconIMG from '../../assets/Logo/slides.png';
import MyLogo from "./Logo.module.css";

const Logo = ({ className }) => (
    <img className={[MyLogo.logo, className].filter(Boolean).join(' ')} alt="milegrid-logo" src={iconIMG} />
);

export default Logo;
